import store from '@/app/store/vuex';
import { ROLE_DEMO_CUSTOMER } from 'App/constants/Roles';
import {
  CMS_SUB_TABS,
  CMS_TAB_PRODS,
  CMS_TAB_PRODS_DRAFT,
  matchesTabRoles,
  PRODUCTS_SUBCATEGORIES_MAP,
  SUB_PRODUCTS_DHW_DEV,
  SUB_PRODUCTS_VAPING_DEV,
  SUB_PRODUCTS_WNS_DEV,
  TEARDOWN_REPORTS,
} from 'App/utils/Collections';

const SUBCATEGORY_PRIORITY = [SUB_PRODUCTS_VAPING_DEV, SUB_PRODUCTS_WNS_DEV, SUB_PRODUCTS_DHW_DEV];

const SUBCATEGORY_ALIASES = {
  [TEARDOWN_REPORTS]: SUB_PRODUCTS_VAPING_DEV,
};

export function hasSubcategoryAccess(subcategory) {
  const { [subcategory]: alias } = SUBCATEGORY_ALIASES;
  const roles = PRODUCTS_SUBCATEGORIES_MAP[alias || subcategory]?.requiredRoles;
  if (!roles) {
    return true;
  }

  if (store.state.user.hasAccess(ROLE_DEMO_CUSTOMER)) {
    return true;
  }
  return roles.some((role) => store.state.user.hasAccess(role));
}

// Outside the products tabs, role-restricted sub tabs are hidden only in the tab bar,
// so a direct link would otherwise open the hidden sub tab under the first visible one.
function hasCmsSubTabAccess(tab, sub) {
  const subTab = CMS_SUB_TABS[tab]?.find((el) => el.id === sub);
  return !subTab || matchesTabRoles(subTab, store.state.user.hasAccess);
}

export function firstAccessibleProductSubcategory() {
  return SUBCATEGORY_PRIORITY.find(hasSubcategoryAccess) || null;
}

export function guardCmsProductSubcategory(to, from, next) {
  const { tab, sub } = to.params;
  const isProductsTab = [CMS_TAB_PRODS, CMS_TAB_PRODS_DRAFT].includes(tab);
  if (isProductsTab ? !hasSubcategoryAccess(sub) : !hasCmsSubTabAccess(tab, sub)) {
    next('/403');
    return;
  }
  next();
}
